module.exports = __webpack_public_path__ + "static/media/tcm-default.3b4132c9.png";